<script setup>
</script>

<template>
  <div class="d-flex justify-space-between pb-3 mb-10" :class="{ 'border-b': $slots.actions }">
    <div class="title-container text-2xl font-weight-medium text-en-red-500">
      <slot></slot>
    </div>

    <div class="d-flex flex-wrap ga-1 justify-end">
      <slot name="actions"></slot>
    </div>
  </div>
</template>